import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaWhatsapp } from 'react-icons/fa';
import './Thankyou.css';

const ThankYou = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isValidAccess, setIsValidAccess] = useState(false);

  // Extract form data from location state
  const { name, email, phone, message } = location.state || { name: '', email: '', phone: '', message: '' };

  useEffect(() => {
    // Check if the user came from a form submission (name exists)
    if (!name) {
      console.warn('Direct access to Thank You page detected without form data');
      setIsValidAccess(false);
      return;
    }

    setIsValidAccess(true);

    // Handle Google Tag Manager event tracking with refresh protection
    handleGtmTracking();

    // Cleanup function
    return () => {
      // Optional cleanup code here
    };
  }, []);

  // Function to safely handle GTM tracking that's robust against refreshes
  const handleGtmTracking = () => {
    if (!name || !window.dataLayer) return;

    // Create a submission ID (without timestamp so it persists across refreshes)
    const submissionId = `submission-${name}-${phone}`;

    // Check if this specific form submission has been tracked before
    if (!sessionStorage.getItem(submissionId)) {
      // Mark this submission as tracked
      sessionStorage.setItem(submissionId, 'tracked');

      // Fire the GTM event
      window.dataLayer.push({
        'event': 'lead_generated',
        'formType': 'contact',
        'formLocation': 'contact_page',
        'customerData': {
          'name': name,
          'email': email || 'Not provided',
          'phone': phone || 'Not provided',
          'hasMessage': Boolean(message)
        }
      });

      console.log('GTM event fired: lead_generated');
    } else {
      console.log('Submission already tracked, skipping duplicate GTM event');
    }
  };

  // Function to safely handle WhatsApp click tracking
  const handleWhatsAppClick = () => {
    if (!name || !window.dataLayer) return;

    // Create a unique WhatsApp click ID that persists
    const whatsappClickId = `whatsapp-${name}-${phone}`;

    if (!sessionStorage.getItem(whatsappClickId)) {
      sessionStorage.setItem(whatsappClickId, 'tracked');

      window.dataLayer.push({
        'event': 'whatsapp_button_click',
        'customerName': name,
        'customerPhone': phone
      });

      console.log('GTM event fired: whatsapp_button_click');
    }
  };

  return (
    <div className="thank-you-container">
      <Helmet>
        {/* Google tag (gtag.js) */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-JGSTMNYSH0"></script>
        <script>
          {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());

                    gtag('config', 'G-JGSTMNYSH0');
                    `}
        </script>
      </Helmet>
      <div className="thank-you-content">
        {isValidAccess ? (
          // Valid form submission
          <>
            <div className="thank-you-success-icon">✓</div>
            <h2>Thank You!</h2>
            <p>Your message has been sent successfully. We'll get back to you soon.</p>

            <div className="thank-you-buttons">
              <Link to="/contact" className="thank-you-new-enquiry">
                Send Another Message
              </Link>

              <a
                href={`https://wa.me/918076353837?text=Hello%2C%20I%20just%20submitted%20an%20inquiry%20on%20your%20website.%20My%20name%20is%20${encodeURIComponent(name)}.`}
                className="thank-you-whatsapp-button"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleWhatsAppClick}
              >
                <FaWhatsapp style={{ marginRight: '8px' }} /> Continue on WhatsApp
              </a>
            </div>
          </>
        ) : (
          // Invalid access - direct URL access
          <>
            <div className="thank-you-invalid-icon">!</div>
            <h2>Oops!</h2>
            <p>It looks like you've accessed this page directly. Please submit a form to see the thank you confirmation.</p>

            <div className="thank-you-buttons">
              <Link to="/contact" className="thank-you-invalid-button">
                Go to Contact Form
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ThankYou;